<template>
  <div class="row">
    <div class="col wrapper">
      <div class="list-group list-group-flush scroller">
        <router-link
          v-for="doctor of doctors"
          :key="doctor.id"
          :to="`/clinic-doctors/${doctor.id}`"
          class="list-group-item list-group-item-action"
          :class="{ active: $route.params.id === doctor.id }"
        >
          <div class="row align-items-center">
            <div class="col-auto">
              <div class="d-flex w-100 justify-content-between">
                <div
                  :style="{
                    backgroundImage: `url(${staticUrl}${doctor.photo})`,
                  }"
                  class="avatar shadow d-inline-block"
                  :class="{ online: doctor && isOnline(doctor.id) }"
                ></div>
              </div>
            </div>
            <div class="col">
              {{ doctor.firstname[authLocale] }}
              {{ doctor.lastname[authLocale] }}
            </div>
          </div>
        </router-link>
        <LoadingMore v-if="loading"></LoadingMore>
        <a
          v-else-if="more"
          @click.prevent="loadMore"
          class="pointer d-block bg-primary text-white text-center py-2"
        >
          <small>{{ $t("loadMore") }}</small>
        </a>
      </div>
    </div>
    <div class="col-9" v-if="$route.params.id">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import LoadingMore from '@/components/Loadings/More'
export default {
  components: {
    LoadingMore
  },
  metaInfo: {
    title: 'Clinic Doctors'
  },
  data () {
    return {
      loading: true,
      limit: 10,
      offset: 0,
      more: true
    }
  },
  computed: {
    ...mapGetters({
      doctors: 'doctor/doctors',
      authLocale: 'auth/locale',
      staticUrl: 'app/staticUrl',
      isOnline: 'status/isOnline'
    })
  },
  mounted () {
    this.fetch()
  },
  methods: {
    ...mapMutations({
      setAlert: 'alert/setAlert',
      setDoctor: 'doctor/set'
    }),
    loadMore (val) {
      this.offset = this.limit + this.offset
      this.fetch()
    },
    async fetch () {
      this.loading = true
      try {
        const params = { offset: this.offset, limit: this.limit }
        const response = await this.axios.get('/api/doctors', {
          params
        })
        const doctors = response.data.data
        for (const doctor of doctors) {
          this.setDoctor({
            id: doctor.id,
            firstname: doctor.firstname,
            lastname: doctor.lastname,
            busy: doctor.busy,
            speciality_id: doctor.speciality_id,
            title: doctor.title,
            experience_from: doctor.experience_from,
            chat: doctor.chat_space,
            clinic_services: doctor.clinic_services,
            photo: doctor.photo,
            country: doctor.country,
            gender: doctor.gender,
            birthdate: doctor.birthdate,
            language: doctor.language,
            languages: doctor.languages,
            email: doctor.email_address,
            phone: doctor.phone_number
          })
          if (doctor.chat_space) {
            this.setChat({
              chat_space: doctor.chat_space,
              id: doctor.chat_space.id,
              last_message: doctor.chat_space.last_message,
              last_seen: doctor.chat_space.last_seen,
              type: 'PatientDoctor'
            })
          }
        }
        if (doctors.length < this.limit) {
          this.more = false
        }
        this.loading = false
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
        this.loading = false
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "loadMore": "მეტის ჩატვირთვა"
  },
  "en": {
      "loadMore": "Load More"
  }
}
</i18n>
